import { Accordion } from "react-bootstrap";
import { useState, useEffect } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import AdminHeader from "../../component/AdminHeader";
import TestimonialSelect from "../../component/TestimonialSelect";

const addHomeTesti = ApiEndpoints.testimonial.create;
const getHomeTesti = ApiEndpoints.testimonial.edit;
const deleteHomeTesti = ApiEndpoints.testimonial.delete;
const updateHomeTesti = ApiEndpoints.testimonial.update;

export default function Testimonial() {
  const [testimonials, setTestimonials] = useState([]);
  const [previews, setPreviews] = useState({});

  const addTestimonial = () => {
    setTestimonials([
      ...testimonials,
      {
        _id: null,
        client_image: "",
        client_name: "",
        description: "",
        client_location: "",
        rank: "",
        testimonial_category: null,
      },
    ]);
  };

  const fetchData = async () => {
    try {
      const response = await ApiRequest("GET", getHomeTesti,);
      const initialPreviews = response.Home_testimonial_sections.reduce((acc, testimonial, index) => {
        acc[`testimonial${index + 1}preview`] = `${BaseUrl}${testimonial.client_image}` || "";
        return acc;
      }, {});
      setTestimonials(response.Home_testimonial_sections);
      setPreviews(initialPreviews);
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [])

  const handleChange = (id, field, value) => {
    setTestimonials((prevTestimonials) =>
      prevTestimonials.map((testimonial) =>
        testimonial._id === id
          ? { ...testimonial, [field]: value }
          : testimonial
      )
    );
  };

  const handleImageChange = (id, field, e) => {
    const file = e.target.files[0];
    const testimonialIndex = testimonials.findIndex((testimonial) => testimonial._id === id);
    const previewKey = `testimonial${testimonialIndex + 1}preview`;

    if (file) {
      // Update the preview state dynamically for client_image 
      if (field === "client_image") {
        setPreviews((prevPreviews) => ({
          ...prevPreviews,
          [previewKey]: URL.createObjectURL(file),
        }));
      }

      // Update the testimonial's respective field
      setTestimonials((prevTestimonials) =>
        prevTestimonials.map((testimonial) =>
          testimonial._id === id
            ? { ...testimonial, [field]: file }
            : testimonial
        )
      );
    } else {
      // Reset the preview state dynamically for client_image
      if (field === "client_image") {
        setPreviews((prevPreviews) => ({
          ...prevPreviews,
          [previewKey]: null,
        }));
      }

      // Reset the testimonial's respective field
      setTestimonials((prevTestimonials) =>
        prevTestimonials.map((testimonial) =>
          testimonial._id === id
            ? { ...testimonial, [field]: null }
            : testimonial
        )
      );
    }
  };


  const handleSubmit = async (id) => {
    const testimonialToSubmit = testimonials.find((testimonial) => testimonial._id === id);
    const isNew = testimonialToSubmit._id === null; // Check if it's a new testimonial

    // Validation for null
    if (
      !testimonialToSubmit.client_image || !testimonialToSubmit.description || !testimonialToSubmit.client_name || !testimonialToSubmit.client_location || testimonialToSubmit.rank === ""
    ) {
      toast.error("All fields for testimonial are required.");
      return;
    }

    const formData = new FormData();
    formData.append("client_name", testimonialToSubmit.client_name);
    formData.append("description", testimonialToSubmit.description);
    formData.append("client_location", testimonialToSubmit.client_location);
    formData.append("rank", testimonialToSubmit.rank);
    formData.append("testimonial_category", testimonialToSubmit.testimonial_category);

    // Append bg image file
    if (testimonialToSubmit.client_image instanceof File) {
      formData.append("client_image", testimonialToSubmit.client_image);
    }

    // Append _id only for updates
    if (!isNew) {
      formData.append("_id", testimonialToSubmit._id);
    }

    try {
      const apiEndpoint = isNew ? addHomeTesti : updateHomeTesti; // Define endpoints explicitly

      const response = await ApiRequest("POST", apiEndpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response?.error) {
        toast.error(response.message || "Something went wrong.");
        return;
      }
      toast.success(response.message);
      fetchData();
    } catch (error) {
      console.error(isNew ? "Error adding testimonial:" : "Error updating testimonial:", error);
    }

    formData.append("rank", testimonialToSubmit.rank);
    formData.append(
      "testimonial_category",
      testimonialToSubmit.testimonial_category
    );

  };

  const deleteTestimonial = async (id) => {
    try {
      await ApiRequest("POST", `${deleteHomeTesti}/${id}`);
      fetchData();
      toast.success("Testimonial deleted successfully.");
    } catch (error) {
      console.error("Error deleting Testimonial:", error);
    }
  };

  const pagename = {
    name: 'Testimonial Management',
    user: 'Admin',
    innerpage: 'Testimonial Management / Testimonials'
  }


const testimonialCategoryOptions = [
  { _id: "all", name: "All" },
  { _id: "interior", name: "Interior / Turnkey Page" },
  { _id: "PMS", name: "PMS Page" },
];


  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <div className="add-content-wrap">
          <div className="row">
            <div className="col-lg-12">
              <div className="home-slove-accord">
                <Accordion defaultActiveKey="0">
                  {testimonials.map((testimonial, index) => {
                    const previewKey = `testimonial${index + 1}preview`;
                    return (
                      <Accordion.Item eventKey={index.toString()} key={testimonial._id}>
                        <Accordion.Header>{`Testimonial ${index + 1}`}</Accordion.Header>
                        <Accordion.Body>
                          <form onSubmit={(e) => { e.preventDefault(); handleSubmit(testimonial._id); }}>
                            <div className="row">

                              <div className="col-lg-12">
                                <div className="add-page-inputs testimonial-description">
                                  <div className="label-wrap-add">
                                    <label>text<small>*</small></label>
                                  </div>
                                  <DynamicCKEditor data={testimonial.description} onChange={(event) => {
                                    const data = event.editor.getData();
                                    handleChange(testimonial._id, "description", data);
                                  }} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="add-page-inputs input-add-image">
                                  <div className="label-wrap-add">
                                    <label>Client Image: (80 × 80 px)<small>*</small></label>
                                  </div>
                                  <CustomImageUpload name="client_image"
                                    onImageChange={(e) => handleImageChange(testimonial._id, "client_image", e)}
                                    imagePreview={previews[previewKey]}
                                    maxSize={200 * 1024} // 320KB
                                    acceptedFormats={[".webp", ".svg"]} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="add-page-inputs">
                                  <div className="label-wrap-add">
                                    <label>Client name<small>*</small></label>
                                  </div>
                                  <input type="text" className="form-control" placeholder="Enter Here" name="client_name" value={testimonial.client_name} onChange={(e) => handleChange(testimonial._id, "client_name", e.target.value)} />
                                </div>

                                <div className="add-page-inputs">
                                  <div className="label-wrap-add">
                                    <label>Client Location / Company Name<small>*</small></label>
                                  </div>
                                  <input type="text" className="form-control" placeholder="Enter Here" name="client_location" value={testimonial.client_location} onChange={(e) => handleChange(testimonial._id, "client_location", e.target.value)} />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="add-page-inputs">
                                  <div className="label-wrap-add">
                                    <label>Rank<small>*</small></label>
                                  </div>
                                    <input type="number" className="form-control" value={testimonial.rank || ""} onChange={(e) => handleChange(testimonial._id, "rank", e.target.value)}/>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="add-page-inputs">
                                  <div className="label-wrap-add">
                                    <label>Shows On<small>*</small></label>
                                  </div>
                                 <TestimonialSelect
                                  placeholder="Select"
                                  options={testimonialCategoryOptions}
                                  defaultValue={
                                    testimonialCategoryOptions.find(
                                      (opt) =>
                                        opt._id === (testimonial.testimonial_category ?? "all")
                                    )
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      testimonial._id,
                                      "testimonial_category",
                                      e.target.value === "all" ? null : e.target.value
                                    )
                                  }
                                />
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="btn-group-home-solve">
                                  <button type="submit" className="default-btn">save <span></span></button>
                                  <button onClick={() => deleteTestimonial(testimonial._id)} type="button" className="delete-solve"><img src="/assets/admin-delete.webp" alt="delete" className="img-responsive" /></button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </Accordion.Body>
                      </Accordion.Item>
                    )
                  })}
                  <div className="add-page-inputs">
                    <div className="addmore-images-client" onClick={addTestimonial}>Add Testimonial +</div>
                  </div>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
